import { hasUserAuthPrefix, useAuthorizationToken } from "../services/auth/authToken";

/**
 * Is a signed-in user driving this page?
 *
 * Subscribed to the credential itself. It used to call `useCookies(["resume"])` and then read
 * `cookies["Authorization"]` — the value it wanted and the key it watched were different, so a
 * sign-in never re-rendered the caller.
 */
const useIsLoggedIn = () => {
	const token = useAuthorizationToken();

	return hasUserAuthPrefix(token);
};

export default useIsLoggedIn;
